import { Tooltip, IconButton, type SvgIconProps } from '@mui/material';
import type { FC } from 'react';
import { ButtonWrapper } from '../ButtonWrapper';
import { IconLabel } from '../IconLabel';

export interface SimpleMenuItemProps {
  disabled?: boolean;
  tooltipText?: string;
  onClick: () => void;
  title: string;
  testId: string;
  icon: React.FC<SvgIconProps>;
}

export const SimpleMenuItem: FC<SimpleMenuItemProps> = ({ disabled, tooltipText, onClick, title, testId, icon }) => {
  const Icon = icon;
  const content = (
    <IconButton size="small" data-testid={testId} onClick={onClick}>
      <Icon color="secondary" fontSize="medium" />
    </IconButton>
  );
  return (
    <ButtonWrapper disabled={disabled}>
      {tooltipText ? (
        <Tooltip title={tooltipText} placement="bottom">
          {content}
        </Tooltip>
      ) : (
        content
      )}
      <IconLabel>{title}</IconLabel>
    </ButtonWrapper>
  );
};
